import { heroStats } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden bg-primary-950">
      <img
        src="https://readdy.ai/api/search-image?query=editorial%20pop%20culture%20magazine%20cover%20scene%2C%20a%20giant%20cracked-open%20fresh%20watermelon%20revealing%20juicy%20red%20flesh%20with%20glossy%20black%20seeds%2C%20surrounded%20by%20floating%20film%20clapperboards%2C%20golden%20award%20stars%2C%20glowing%20play%20buttons%20and%20lightning%20bolts%2C%20deep%20warm%20crimson%20and%20champagne%20gold%20palette%2C%20stylized%20flat%20pop%20art%20vector%2C%20high%20detail%2C%20cinematic%20lighting%2C%20no%20text&width=1600&height=900&seq=hero-cover-main&orientation=landscape"
        alt="吃瓜王 大主视觉：切开的西瓜与金色星光"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-primary-950/70 to-black/40" />
      <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-primary-950/80 to-transparent" />

      <div className="relative z-10 mx-auto flex min-h-[600px] w-full max-w-7xl flex-col items-start justify-center px-4 pb-20 pt-10 md:min-h-[660px] md:px-6">
        <div className="animate-riseIn flex flex-wrap items-center gap-2.5">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-400 px-3 py-1 text-xs font-bold text-primary-950">
            <span className="inline-block h-2 w-2 animate-pulseDot rounded-full bg-primary-900" />
            实时热搜 · 今日已开 23 关
          </span>
          <span className="chip !border-background-100/25 !bg-background-100/10 !text-background-50">
            <i className="ri-fire-fill mr-1 text-accent-300" aria-hidden="true" />
            全站答题人次 861 万
          </span>
        </div>

        <h1 className="mt-6 max-w-3xl font-heading text-4xl font-black leading-[1.1] tracking-tight text-background-50 md:text-6xl">
          今天，你的八卦
          <span className="block text-accent-300">到底有多准？</span>
        </h1>

        <p className="mt-5 max-w-xl text-base leading-relaxed text-background-100/90 md:text-lg">
          从影视名场面到互联网热梗，<strong className="font-bold text-background-50">吃瓜王答题</strong>
          一题接一题考你的瓜界直觉。趣味题目搭配实时热点，
          <strong className="font-bold text-accent-200">吃瓜王测试</strong>摸清段位，
          <strong className="font-bold text-background-50">吃瓜王闯关挑战</strong>一路连答——看看你能闯到第几关。
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <a href="#play" className="btn-primary cursor-pointer !px-7 !py-3.5 !text-base">
            立即开始挑战
            <i className="ri-arrow-right-line ml-2 text-lg" aria-hidden="true" />
          </a>
          <a href="#feed" className="btn-ghost cursor-pointer !border-background-100/30 !text-background-50 hover:!border-accent-300 hover:!text-accent-200 !px-7 !py-3.5 !text-base">
            先逛逛今日瓜田
          </a>
        </div>

        {/* stat row */}
        <div className="mt-10 grid w-full max-w-3xl grid-cols-3 gap-3 border-t border-background-100/20 pt-6">
          {heroStats.map((s) => (
            <div key={s.label} className="pr-2">
              <div className="font-display text-2xl font-bold tracking-wide text-accent-300 md:text-3xl">
                {s.value}
              </div>
              <div className="mt-1 text-xs text-background-100/70 md:text-sm">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}